/* 2026 PDP information drawers.

   Replaces the inline <script> that product-block-tabs shipped in the body.
   Delegated from document, so it survives the block being re-rendered on a
   variant change and needs no re-binding. */
(function () {
  const OPEN_SLIDE = 'product--info--drawer--slide--active';
  const OPEN_OVERLAY = 'product--info--drawer--slide--overlay--active';

  const PORTAL_ID = 'pdp2026-drawer-portal';

  const slides = () => document.querySelectorAll('.product--info--drawer--slide');
  const overlay = () => document.querySelector('.product--info--drawer--slide--overlay');
  const header = () =>
    document.querySelector('.section-header.shopify-section-group-header-group');

  /* The drawer renders inside product-info.product__column-sticky, which is
     `position: sticky; z-index: 2` -- a stacking context. A fixed child cannot
     escape it, so however high the drawer's own z-index goes it is still
     painted at level 2 of the page, and the sticky site header (z-index 1000)
     covers its title bar.

     Moving it to the body is what the live theme does, for the same reason:
     product-block-tabs portals the overlay and both drawers into a div it
     appends to <body>. Done here rather than in the header so nothing about
     the header changes. */
  function portalRoot() {
    let root = document.getElementById(PORTAL_ID);
    if (!root) {
      root = document.createElement('div');
      root.id = PORTAL_ID;
      document.body.appendChild(root);
    }
    return root;
  }

  function portal() {
    const root = portalRoot();

    /* Only nodes still sitting where Liquid rendered them. A section re-render
       produces a fresh set beside the ones already moved, so finding any here
       means the portal is holding a stale copy -- empty it before refilling.
       Finding none means everything is already in place and this is a no-op.

       The size guide rides along: size-chart.liquid renders inside
       <product-info> too, and it was losing to the site header for the same
       reason. Its own markup is shared with the 2025 and legacy templates, so
       it is moved from here rather than changed there. */
    const fresh = [
      ...document.querySelectorAll(
        '.product--info--drawer--slide--overlay, .product--info--drawer--slide, #sizeChartPopup, #overlay__size__chart'
      ),
    ].filter((node) => !root.contains(node));

    if (!fresh.length) return;
    root.replaceChildren();
    fresh.forEach((node) => root.appendChild(node));
  }

  function closeAll() {
    slides().forEach((slide) => slide.classList.remove(OPEN_SLIDE));
    overlay()?.classList.remove(OPEN_OVERLAY);
    header()?.classList.remove('product--info--drawer--open--now');
    document.body.classList.remove('scroll_lock');
  }

  function open(selector) {
    portal();
    const slide = document.querySelector(selector);
    if (!slide) return;
    slides().forEach((s) => s.classList.remove(OPEN_SLIDE));
    slide.classList.add(OPEN_SLIDE);
    overlay()?.classList.add(OPEN_OVERLAY);
    header()?.classList.add('product--info--drawer--open--now');
    document.body.classList.add('scroll_lock');
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target.closest) return;

    if (target.closest('.pdp2026-drawers .drawer--opener--one')) {
      open('.product--info--drawer--slide--one');
      return;
    }
    if (target.closest('.pdp2026-drawers .drawer--opener--two')) {
      open('.product--info--drawer--slide--two');
      return;
    }
    if (
      target.closest('.product--info--drawer--close') ||
      target.classList.contains('product--info--drawer--slide--overlay')
    ) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('shopify:section:load', portal);

  /* The size guide is opened by size-chart.liquid's own handler, so portal on
     the way in rather than waiting for a section load. Capture phase, so this
     runs before that handler adds the active class. */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (target.closest && target.closest('[data-pdp2026-size-guide], #sizeChartBtn')) portal();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portal);
  } else {
    portal();
  }
})();
